module.exports = __webpack_public_path__ + "53e87dc1874e487d38eeba168d8ff54e.png";